// extracted by mini-css-extract-plugin
export var cartContainer = "_qy-4";
export var gray = "_qy-1";
export var itemContainer = "_qy-2";
export var itemDetails = "_qy-3";
export var strong = "_qy-0";